import { makeAutoObservable } from 'mobx'

/**
 * @class SprintsStore
 * @description This class represents the store for sprints. It manages the state of sprints and is part of the root store.
 */
class SprintsStore {
	/**
	 * @property {Object} sprints - An object containing sprints indexed by their IDs.
	 */
	sprints = {}

	/**
	 * @constructor
	 * @param {Object} rootStore - The root store that holds the global state and other stores.
	 * @description Constructs an instance of SprintsStore and makes it observable.
	 */
	constructor(rootStore) {
		this.rootStore = rootStore
		makeAutoObservable(this)
	}
}

export default SprintsStore
